import { FormInstance } from 'antd/lib/form';
import React from 'react';
import { LabelAndKey } from './types/LabelAndKey';
import GenericSelector from './GenericSelector';

interface Props {
    dependencies?: string[]
    fieldValidator?(rule: any, value: any): Promise<void>
    criterion?: any
    form: FormInstance
}

const SubICBLocationSelector = ({dependencies, fieldValidator, criterion, form }: Props) => {

    const toLabel = (e: LabelAndKey) => {
        return e.label + ' (' + e.key + ')'
    }

    return <GenericSelector
        fieldId="subICBLocations"
        fieldLabel="SUB ICB Location (Formerly CCG/HB)"
        fieldURL="/subICBLocations"
        dependencies={dependencies}
        fieldValidator={fieldValidator}
        fieldLabelFunction={toLabel}
        criterion={criterion}
        form={form}
    />
}

export default SubICBLocationSelector